import {NgModule} from '@angular/core';
import {MatButtonModule, MatIconModule} from '@cdk/angular/material';

import {NavbarVerticalStyle1Component} from './style-1.component';
import {TourModule} from '../../../../../../ajuda/tour/tour.module';
import { CdkNavigationComponent } from '@cdk/components/navigation/navigation.component';

@NgModule({
    imports: [
    MatButtonModule,
    MatIconModule,
    CdkNavigationComponent,
    TourModule,
    NavbarVerticalStyle1Component
],
    exports: [
        NavbarVerticalStyle1Component
    ]
})
export class NavbarVerticalStyle1Module {
}
